import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { from } from 'rxjs';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import {
  PolicyModule as PlatformPolicyModule,
  SharedModule as PlatformSharedModule,
  BillingModule as PlatformBillingModule
} from '@dx/platform-components';

import { GoToInputModule } from '../core/components/go-to-input/go-to-input.module';
import { HeaderCurveModule } from '../core/components/header-curve/header-curve.module';
import { BillingStatementsTabComponent } from './billing-statements-tab/billing-statements-tab.component';
import { BillingTransactionsTabComponent } from './billing-transactions-tab/billing-transactions-tab.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PageAccessDeniedComponent } from './page-access-denied/page-access-denied.component';
import { PageErrorComponent } from './page-error/page-error.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PageNavbarComponent } from './page-navbar/page-navbar.component';
import { AppUnauthorizedPageComponent } from './app-unauthorized-page/app-unauthorized-page.component';

@NgModule({
  declarations: [
    BillingStatementsTabComponent,
    BillingTransactionsTabComponent,
    NotFoundComponent,
    PageAccessDeniedComponent,
    PageErrorComponent,
    PageHeaderComponent,
    PageNavbarComponent,
    AppUnauthorizedPageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    NgbDropdownModule,
    PlatformBillingModule,
    PlatformPolicyModule,
    PlatformSharedModule,
    GoToInputModule,
    HeaderCurveModule
  ],
  exports: [
    CommonModule,
    FontAwesomeModule,
    PlatformPolicyModule,
    PlatformSharedModule,
    GoToInputModule,
    HeaderCurveModule,
    BillingStatementsTabComponent,
    BillingTransactionsTabComponent,
    NotFoundComponent,
    PageAccessDeniedComponent,
    PageErrorComponent,
    PageHeaderComponent,
    PageNavbarComponent,
    AppUnauthorizedPageComponent
  ]
})
export class SharedModule { }
